import { usdtAbi, SELLWINE_ABI } from "./abi";
import { Notify } from "vant";
import store from "@/store";
import Web3 from "web3";
export let gasPrice = "3000000000";
let web3Provider;
export let WEB3;
export let web3js;
let { ethereum } = window;
export let selectAddress = "";
const MAX_NUMBER =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";
const MAX_NUMBER160 = "1461501637330902918203684832716283019655932542975";
const networkVersion = "196"; //56  97测试
export let isChainId = true;

/** X Layer 公开 RPC：无注入钱包时的默认节点；未初始化钱包时的只读合约调用走此节点 */
export const PUBLIC_RPC_URL = "https://rpc.xlayer.tech";

if (ethereum) {
  console.log(ethereum, "ethereum");
  web3Provider = ethereum;
} else if (window.web3) {
  web3Provider = web3.currentProvider;
} else {
  web3Provider = new Web3.providers.HttpProvider(PUBLIC_RPC_URL);
}
WEB3 = new Web3(web3Provider);
export async function checkNetwork(web3js) {
  try {
    let res = await web3js.eth.net.getId();
    console.log(res,'das');
    if (res != networkVersion) {
      isChainId = false;
      Notify({ type: "danger", message: "error network" });
    } else {
      isChainId = true;
    }
  } catch (err) {}
}
// 购买合约
export const sellWineContract = "0xFba89F9828C8D2402Fb8DB750dE677Ca9469cac5";
export let sellWineContractInstance;

let readOnlyWeb3;
let readOnlySellWineContract;

function getReadOnlySellWineContract() {
  if (!readOnlyWeb3) {
    readOnlyWeb3 = new Web3(new Web3.providers.HttpProvider(PUBLIC_RPC_URL));
    readOnlySellWineContract = new readOnlyWeb3.eth.Contract(
      SELLWINE_ABI,
      sellWineContract
    );
  }
  return readOnlySellWineContract;
}

/** 奖金池等纯 view：未连接钱包时用 PUBLIC_RPC_URL 发起 eth_call；已连接则用当前钱包 Provider */
function getSellWineContractForRead() {
  if (sellWineContractInstance) {
    return sellWineContractInstance;
  }
  return getReadOnlySellWineContract();
}

const tokenContract = "0x1e4a5963abfd975d8c9021ce480b42188849d41d";
let tokenContractInstance;

export const contractInstanceInit = function (provider, account) {
  web3js = provider;
  selectAddress = account;
  store.commit("SET_ADDRESS", selectAddress);
  checkNetwork(web3js);
  web3js.eth.getGasPrice().then((res) => {
    gasPrice = res;
  });
  return new Promise((resolve) => {
    sellWineContractInstance = new web3js.eth.Contract(
      SELLWINE_ABI,
      sellWineContract
    );
    tokenContractInstance = new web3js.eth.Contract(usdtAbi, tokenContract, {
      from: selectAddress,
      gasPrice: "0",
    });
    console.log(sellWineContractInstance);
    resolve();
  });
};

// 代币授权
export const approveToken = function () {
  return new Promise((resolve, reject) => {
    tokenContractInstance.methods
      .approve(sellWineContract, MAX_NUMBER)
      .send({
        from: selectAddress,
        gasPrice: gasPrice,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};
// 检查是否授权
// 注意：Web3 1.x 下 .call(opts, callback) 的 callback 签名为 (error, result)。
// 不能把「仅处理 error 的函数」当作第二参数；成功时 error 为 null，若误用 ?? 会当成失败。
export const allowToken = function (backFunction, errorFunction) {
  tokenContractInstance.methods
    .allowance(selectAddress, sellWineContract)
    .call({
      from: selectAddress,
    })
    .then((result) => backFunction(result))
    .catch((err) => {
      if (typeof errorFunction === "function") {
        errorFunction(err);
      }
    });
};

/**
 * 从 buy 交易 receipt 中取出 buyEvent（ABI: user, amount, price, number, timestamp）
 * @returns {object|null} 单条时为 { user, amount, price, number, timestamp }，均为十进制字符串便于展示/提交后端
 */
export function parseBuyEventFromReceipt(receipt) {
  const raw = receipt?.events?.buyEvent;
  if (raw == null) return null;

  const evt = Array.isArray(raw) ? raw[0] : raw;
  const rv = evt?.returnValues;
  if (!rv) return null;

  return {
    user: rv.user,
    amount: toDecString(rv.amount),
    price: toDecString(rv.price),
    number: toDecString(rv.number),
    timestamp: toDecString(rv.timestamp),
  };
}

function toDecString(v) {
  if (v == null || v === "") return "";
  try {
    if (Web3.utils.isBN(v)) return v.toString(10);
  } catch (_) {
    //
  }
  if (typeof v === "bigint") return v.toString();
  return String(v);
}

/**
 * SellWine.isOwner() 无参，内部为 msg.sender == manager。
 * eth_call 必须通过 `from` 指定要校验的钱包地址。
 */
export function checkIsSellWineOwner(userAddress) {
  const raw = String(userAddress || "").trim();
  if (!raw || !Web3.utils.isAddress(raw)) {
    return Promise.resolve(false);
  }
  const from = Web3.utils.toChecksumAddress(raw);
  return getSellWineContractForRead()
    .methods.isOwner()
    .call({ from })
    .then((res) => Boolean(res));
}

const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

/**
 * 查询用户在卖酒合约中的上级地址（getParent）。
 * @returns {Promise<string>} 有效上级为 checksum 地址；无上级或零地址返回空字符串
 */
export function getSellWineParent(userAddress) {
  const raw = String(userAddress || "").trim();
  if (!raw || !Web3.utils.isAddress(raw)) {
    return Promise.resolve("");
  }
  const user = Web3.utils.toChecksumAddress(raw);
  return getSellWineContractForRead()
    .methods.getParent(user)
    .call()
    .then((parent) => {
      const p = String(parent || "").trim();
      if (!p || !Web3.utils.isAddress(p)) return "";
      const checksum = Web3.utils.toChecksumAddress(p);
      if (checksum.toLowerCase() === ZERO_ADDRESS) return "";
      return checksum;
    });
}

/**
 * SellWine.isBuy：是否允许以上级地址下单（view）
 * @param {string} parentAddress 父级地址
 */
export function isBuy(parentAddress) {
  const raw = String(parentAddress || "").trim();
  if (!Web3.utils.isAddress(raw)) {
    return Promise.reject(new Error("无效的上级地址"));
  }
  const parent = Web3.utils.toChecksumAddress(raw);
  console.log(parent,'parent');
  return getSellWineContractForRead()
    .methods.isBuy(parent)
    .call()
    .then((res) => Boolean(res));
}

/** 当前已连接钱包是否为合约 manager（依赖 selectAddress） */
export const isOwner = function () {
  if (!selectAddress) return Promise.resolve(false);
  return checkIsSellWineOwner(selectAddress);
};

//购买
export const buy = (num, parent) => {
  return new Promise((resolve, reject) => {
    sellWineContractInstance.methods
      .buy(num, parent)
      .send({
        from: selectAddress,
        gasPrice: gasPrice,
      })
      .then((receipt) => {
        const txHash = receipt?.transactionHash;
        console.log("[sellWine] buy receipt tx:", txHash);
        const buyEvent = parseBuyEventFromReceipt(receipt);
        receipt.buyEvent = buyEvent;
        console.log("[sellWine] buy buyEvent 解析数据:", buyEvent);

        resolve({...buyEvent,hash: txHash});
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//获取各级奖金池金额
export const getRewardPoolAmount = function () {
  return new Promise((resolve, reject) => {
    getSellWineContractForRead()
      .methods.getRewardPoolAmount()
      .call()
      .then((res) => {
        console.log(res,'poll res');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const ZERO_ADDR = "0x0000000000000000000000000000000000000000";

/**
 * 读取 nodeList 全部地址。合约无单独 length getter，按下标递增直至越界回退。
 */
export async function getNodeListAddresses() {
  const c = getSellWineContractForRead();
  const out = [];
  const max = 5000;
  for (let i = 0; i < max; i += 1) {
    let addr;
    try {
      addr = await c.methods.nodeList(i).call();
    } catch (_) {
      break;
    }
    const lc = String(addr).toLowerCase();
    if (!lc || lc === ZERO_ADDR) {
      break;
    }
    try {
      out.push(Web3.utils.toChecksumAddress(addr));
    } catch (_) {
      break;
    }
  }
  return out;
}

/** SellWine.addNode（仅 manager / onlyOwner） */
export const addNode = function (nodeAddress) {
  const raw = String(nodeAddress || "").trim();
  if (!Web3.utils.isAddress(raw)) {
    return Promise.reject(new Error("无效的节点地址"));
  }
  const addr = Web3.utils.toChecksumAddress(raw);
  return new Promise((resolve, reject) => {
    if (!sellWineContractInstance) {
      reject(new Error("请先连接钱包"));
      return;
    }
    if (!selectAddress) {
      reject(new Error("请先连接钱包"));
      return;
    }
    sellWineContractInstance.methods
      .addNode(addr)
      .send({
        from: selectAddress,
        gasPrice: gasPrice,
      })
      .then((receipt) => resolve(receipt))
      .catch((err) => reject(err));
  });
};

/** SellWine.removeNode（仅 manager） */
export const removeNode = function (nodeAddress) {
  const raw = String(nodeAddress || "").trim();
  if (!Web3.utils.isAddress(raw)) {
    return Promise.reject(new Error("无效的节点地址"));
  }
  const addr = Web3.utils.toChecksumAddress(raw);
  return new Promise((resolve, reject) => {
    if (!sellWineContractInstance) {
      reject(new Error("请先连接钱包"));
      return;
    }
    if (!selectAddress) {
      reject(new Error("请先连接钱包"));
      return;
    }
    sellWineContractInstance.methods
      .removeNode(addr)
      .send({
        from: selectAddress,
        gasPrice: gasPrice,
      })
      .then((receipt) => resolve(receipt))
      .catch((err) => reject(err));
  });
};

/** SellWine.allocateRewardPool（仅 manager）：_level 1–5，_rewardPoolList 用户地址数组 */
export const allocateRewardPool = function (level, rewardPoolList) {
  const lv = Number(level);
  if (!Number.isInteger(lv) || lv < 1 || lv > 5) {
    return Promise.reject(new Error("无效的奖金池级别"));
  }
  if (!Array.isArray(rewardPoolList) || !rewardPoolList.length) {
    return Promise.reject(new Error("奖金池用户列表不能为空"));
  }
  const addrs = rewardPoolList.map((a) => {
    const s = String(a || "").trim();
    if (!Web3.utils.isAddress(s)) {
      throw new Error(`无效的用户地址: ${s || "(空)"}`);
    }
    return Web3.utils.toChecksumAddress(s);
  });
  return new Promise((resolve, reject) => {
    if (!sellWineContractInstance) {
      reject(new Error("请先连接钱包"));
      return;
    }
    if (!selectAddress) {
      reject(new Error("请先连接钱包"));
      return;
    }
    sellWineContractInstance.methods
      .allocateRewardPool(String(lv), addrs)
      .send({
        from: selectAddress,
        gasPrice: gasPrice,
      })
      .then((receipt) => resolve(receipt))
      .catch((err) => reject(err));
  });
};

/** SellWine.getUserInfo：直推数、推荐奖励、级别奖励、节点标记、节点奖励 */
export const getUserInfo = function (userAddress) {
  const raw = String(userAddress || "").trim();
  if (!Web3.utils.isAddress(raw)) {
    return Promise.reject(new Error("无效的钱包地址"));
  }
  const addr = Web3.utils.toChecksumAddress(raw);
  return new Promise((resolve, reject) => {
    getSellWineContractForRead()
      .methods.getUserInfo(addr)
      .call()
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

/** SellWine.getdirectReferralList：直推地址数组 */
export const getdirectReferralList = function (userAddress) {
  const raw = String(userAddress || "").trim();
  if (!Web3.utils.isAddress(raw)) {
    return Promise.reject(new Error("无效的钱包地址"));
  }
  const addr = Web3.utils.toChecksumAddress(raw);
  return new Promise((resolve, reject) => {
    getSellWineContractForRead()
      .methods.getdirectReferralList(addr)
      .call()
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

/** SellWine.getNodeNowReward：待提取节点奖励（USDT 6 位精度） */
export const getNodeNowReward = function (userAddress) {
  const raw = String(userAddress || "").trim();
  if (!Web3.utils.isAddress(raw)) {
    return Promise.reject(new Error("无效的钱包地址"));
  }
  const addr = Web3.utils.toChecksumAddress(raw);
  return getSellWineContractForRead()
    .methods.getNodeNowReward(addr)
    .call();
};

/** SellWine.getNodeHasReward：已提取节点奖励（USDT 6 位精度） */
export const getNodeHasReward = function (userAddress) {
  const raw = String(userAddress || "").trim();
  if (!Web3.utils.isAddress(raw)) {
    return Promise.reject(new Error("无效的钱包地址"));
  }
  const addr = Web3.utils.toChecksumAddress(raw);
  return getSellWineContractForRead()
    .methods.getNodeHasReward(addr)
    .call();
};

/** SellWine.drawNodeReward：节点用户提取待发放节点奖励 */
export const drawNodeReward = function () {
  return new Promise((resolve, reject) => {
    if (!sellWineContractInstance) {
      reject(new Error("请先连接钱包"));
      return;
    }
    if (!selectAddress) {
      reject(new Error("请先连接钱包"));
      return;
    }
    sellWineContractInstance.methods
      .drawNodeReward()
      .send({
        from: selectAddress,
        gasPrice: gasPrice,
      })
      .then((receipt) => resolve(receipt))
      .catch((err) => reject(err));
  });
};